import { AnyAction } from 'redux';

const SET_SELECTED_SITE_PERSONNEL = 'SET_SELECTED_SITE_PERSONNEL';
const initialState = {
  selectedsitepersonnel: []
};
export async function setselectedSitePersonnel(dispatch: any, sitePersonnel: any) {
  dispatch({
    type: SET_SELECTED_SITE_PERSONNEL,
    data: sitePersonnel
  });
}

const selectedsitePersonnelReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case SET_SELECTED_SITE_PERSONNEL: {
      return {
        ...state,
        selectedsitepersonnel: action.data
      };
    }

    default:
      return state;
  }
};

export default selectedsitePersonnelReducer;
